import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  OPEN_WIZARD_BUTTON: `${cleanedFilename(__filename)}-open-wizard-button`,
};
